// HomeScholar Pro brand crest — forest shield + brass border + cream graduation cap.
// Companion to HomeGrade Pro's transcript-card crest (same shield system). Drawn on a
// 96×108 viewBox. variant="light" for light surfaces; "dark" reverses (brass shield)
// for dark/reversed contexts.
type CrestProps = { size?: number; variant?: 'light' | 'dark'; className?: string; title?: string };

export function Crest({ size = 32, variant = 'light', className, title = 'HomeScholar Pro' }: CrestProps) {
  const dark = variant === 'dark';
  const shield = dark ? '#a87f2f' : '#1d4434';
  const shieldStroke = dark ? '#f0ead6' : '#a87f2f';
  const cap = dark ? '#1d4434' : '#f0ead6';
  const capStroke = dark ? '#142f24' : '#a87f2f';
  const accent = dark ? '#1d4434' : '#a87f2f';
  const button = dark ? '#142f24' : '#a87f2f';
  return (
    <svg
      width={size}
      height={Math.round((size * 108) / 96)}
      viewBox="0 0 96 108"
      role="img"
      aria-label={title}
      className={className}
    >
      <path d="M14 12 L82 12 L82 46 Q82 72 48 98 Q14 72 14 46 Z" fill={shield} stroke={shieldStroke} strokeWidth={3} />
      <path d="M37 42 Q37 56 48 56 Q59 56 59 42" fill={cap} stroke={capStroke} strokeWidth={1} />
      <polygon points="48,23 69,34 48,45 27,34" fill={cap} stroke={capStroke} strokeWidth={1} />
      <circle cx={48} cy={34} r={2.4} fill={button} />
      <path d="M48 34 L69 34 L69 54" fill="none" stroke={accent} strokeWidth={1.5} />
      <circle cx={69} cy={56} r={2.1} fill={accent} />
    </svg>
  );
}
